import { breakpoints, baseElements } from '../helpers/constants';
import { getElement, getElements, toggleClass } from '../helpers/functions';
import MobileNavigation from './mobile-navigation';
import DesktopNavigation from './desktop-navigation';
import { getScroll } from './smooth-scroll';
const {
  $header
} = baseElements;
const lenis = getScroll();
let currentTransformValue = 0;
let startPoint = null;
let headerHeight = $header.offsetHeight || 140;
const scrollUp = () => {
  currentTransformValue = 0;
  startPoint = null;
  $header.classList.add('_up');
  $header.classList.remove('_down');
  $header.style.transform = 'translate3d(0, 0, 0)';
};
const scrollDown = scrollPos => {
  if (!startPoint) startPoint = scrollPos;
  if (currentTransformValue < headerHeight) {
    currentTransformValue = scrollPos - startPoint;
    $header.classList.remove('_up');
    $header.classList.add('_down');
    $header.style.transform = `translate3d(0, -${currentTransformValue}px, 0)`;
  }
};
const onScroll = (scrollPos, direction) => {
  $header.classList.toggle('_sticky', direction === -1 && scrollPos > 0);
};
class HeaderPanel {
  constructor() {
    this.$headerBtn = getElements('[data-panel]');
    this.$closeBtn = getElements('.header-panel__close');
    this.$headerPanel = getElements('.header-panel');
    this.init();
  }
  static setPanelState(panel) {
    let isOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    toggleClass(panel, '__open', isOpen);
    panel.setAttribute('aria-hidden', (!isOpen).toString());
    panel.setAttribute('tabindex', isOpen ? '0' : '-1');
    panel.inert = !isOpen;
    if (isOpen) {
      lenis.stop();
      scrollUp();
    } else {
      lenis.start();
    }
  }
  static handleHeaderBtnClick = e => {
    e.preventDefault();
    const $btn = e.currentTarget;
    const panelId = $btn.dataset.panel;
    const $panel = getElement(panelId);
    if (!$panel) return;
    if (window.innerWidth < breakpoints.xl && panelId === '#language-panel') return;
    HeaderPanel.setPanelState($panel, true);
  };
  static handleCloseBtnClick = e => {
    const $btn = e.currentTarget;
    const $panel = $btn.closest('.header-panel');
    if (!$panel) return;
    HeaderPanel.setPanelState($panel);
  };
  static closePanel() {
    const openPanel = document.querySelector('.header-panel.__open');
    if (openPanel) {
      HeaderPanel.setPanelState(openPanel);
      // Return focus to the button that opened this panel
      const opener = document.querySelector(`[data-panel="#${openPanel.id}"]`);
      if (opener) {
        opener.focus();
      }
    }
  }
  static handleEscapeKey = e => {
    if (e.key === 'Escape') {
      HeaderPanel.closePanel();
    }
  };
  init() {
    // Initialize panels
    this.$headerPanel.forEach($panel => HeaderPanel.setPanelState($panel));

    // Add event listeners
    this.$headerBtn.forEach($btn => {
      $btn.addEventListener('click', HeaderPanel.handleHeaderBtnClick);
    });
    this.$closeBtn.forEach($btn => {
      $btn.addEventListener('click', HeaderPanel.handleCloseBtnClick);
    });
    document.addEventListener('keydown', HeaderPanel.handleEscapeKey);
  }
}
const header = () => {
  const mobileMenu = new MobileNavigation();
  const desktopMenu = new DesktopNavigation();
  new HeaderPanel();
  lenis.on('scroll', e => {
    const {
      scroll
    } = lenis;
    const {
      direction
    } = e;
    if (direction === 1) {
      scrollDown(scroll);
    } else {
      scrollUp(scroll);
    }
    onScroll(scroll, direction);
  });
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  window.addEventListener('windowResize', e => {
    const {
      windowWidth
    } = e.detail;
    headerHeight = $header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    if (windowWidth < breakpoints.xl) {
      desktopMenu.destroy();
      mobileMenu.create();
    } else {
      mobileMenu.destroy();
      desktopMenu.create();
    }
  });
  document.addEventListener('click', e => {
    if (e.target.matches('body')) {
      desktopMenu.handleCloseClick();
    }
  });
};
export default header;